module.exports = __webpack_public_path__ + "img/6107f0c4c0ccd2.46037379.ccf028fb.png";